import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { UtilityModule } from '../utility/utility.module';
import { SocialFollowIconModule } from '../socialObject/socialFollowIcon/social-follow-icon.module';
import { JourneyIconModule } from '../myJourney/journeyIcon/journey-icon.module';
import { MapIconModule } from '../map/mapIcon/map-icon.module';
import { CareerOneStopVideoComponentModule } from '../career/careerOneStopVideo/career-one-stop-video.component.module';
import {
	TerritoryCardComponent,
	TerritoryCardSplashComponent,
	TerritoryCardActionBarComponent,
	TerritoryCardAtAGlanceComponent,
	TerritoryCardFitStatusComponent,
	TerritoryCardMoreComponent,
	ActionLearnMoreComponent
} from './territory-card.component';
import {
	TerritoryCardInstancesDialog,
	TerritoryCardInstancesComponent
} from './territory-card-instances.component';
import { ActionIconOpenFolderComponent } from '../user/userFileManagementOverview/action-icon-open-folder.component';
import { ActionMoreDeleteFolderComponent } from '../user/userFileManagementOverview/action-more-delete-folder.component';
import { ActionMoreRenameFolderComponent } from '../user/userFileManagementOverview/action-more-rename-folder.component';

import { ActionIconComponent } from './action-icon.component';
import { ActionMoreComponent } from './action-more.component';
import { EditResourceDescriptionComponent } from './edit-resource-description.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule,
		UtilityModule,
		SocialFollowIconModule,
		JourneyIconModule,
		MapIconModule,
		CareerOneStopVideoComponentModule
	],
	declarations: [
		TerritoryCardComponent,
		TerritoryCardSplashComponent,
		TerritoryCardActionBarComponent,
		TerritoryCardAtAGlanceComponent,
		TerritoryCardFitStatusComponent,
		TerritoryCardMoreComponent,
		TerritoryCardInstancesDialog,
		TerritoryCardInstancesComponent,
		ActionLearnMoreComponent,
		ActionIconComponent,
		ActionMoreComponent,
		ActionIconOpenFolderComponent,
		ActionMoreDeleteFolderComponent,
		ActionMoreRenameFolderComponent,
		EditResourceDescriptionComponent
	],
	exports: [
		TerritoryCardComponent,
		ActionLearnMoreComponent,
		ActionIconComponent,
		ActionMoreComponent,
		ActionIconOpenFolderComponent,
		ActionMoreDeleteFolderComponent,
		ActionMoreRenameFolderComponent,
		EditResourceDescriptionComponent
	]
})
export class TerritoryCardModule { }
